import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const HowItWorks = lazy(() => import('../pages/how-it-works/page'));
const PropertyTypes = lazy(() => import('../pages/property-types/page'));
const WeBuyApartmentBuildings = lazy(() => import('../pages/we-buy-apartment-buildings/page'));
const SellMyApartmentBuilding = lazy(() => import('../pages/sell-my-apartment-building/page'));
const TipsForSellingApartmentBuilding = lazy(() => import('../pages/tips-for-selling-apartment-building/page'));
const TenantsAndLeasesPage = lazy(() => import('../pages/tips-for-selling-apartment-building/tenants-and-leases/page'));
const ApartmentBuildingFinancialTerms = lazy(() => import('../pages/apartment-building-financial-terms/page'));
const SellerFinancingBenefits = lazy(() => import('../pages/seller-financing-benefits/page'));
const ApartmentBuildingValuation = lazy(() => import('../pages/apartment-building-valuation/page'));
const Trailing12DeepDive = lazy(() => import('../pages/how-it-works/trailing-12-deep-dive/page'));
const AsIsVsRemodelPage = lazy(() => import('../pages/sell-my-apartment-building/as-is-vs-remodel/page'));
const SellingInheritedApartments = lazy(() => import('../pages/how-it-works/selling-inherited-apartments/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ForSaleByOwnerPage = lazy(() => import('../pages/tips-for-selling-apartment-building/for-sale-by-owner/page'));
const PrivacyAndTermsPage = lazy(() => import('../pages/privacy-and-terms/page'));
const GardenApartmentsPage = lazy(() => import('../pages/we-buy-apartment-buildings/garden-apartments/page'));
const MidRiseApartmentsPage = lazy(() => import('../pages/we-buy-apartment-buildings/mid-rise-apartments/page'));
const SmallApartmentBuildingsPage = lazy(() => import('../pages/we-buy-apartment-buildings/small-apartment-buildings/page').then(m => ({ default: m.default })));
const MixedUsePropertiesPage = lazy(() => import('../pages/we-buy-apartment-buildings/mixed-use-properties/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorks />,
  },
  {
    path: '/how-it-works/trailing-12-deep-dive',
    element: <Trailing12DeepDive />,
  },
  {
    path: '/how-it-works/selling-inherited-apartments',
    element: <SellingInheritedApartments />,
  },
  {
    path: '/property-types',
    element: <PropertyTypes />,
  },
  {
    path: '/we-buy-apartment-buildings',
    element: <WeBuyApartmentBuildings />,
  },
  {
    path: '/we-buy-apartment-buildings/garden-apartments',
    element: <GardenApartmentsPage />,
  },
  {
    path: '/we-buy-apartment-buildings/mid-rise-apartments',
    element: <MidRiseApartmentsPage />,
  },
  {
    path: '/we-buy-apartment-buildings/small-apartment-buildings',
    element: <SmallApartmentBuildingsPage />,
  },
  {
    path: '/we-buy-apartment-buildings/mixed-use-properties',
    element: <MixedUsePropertiesPage />,
  },
  {
    path: '/sell-my-apartment-building',
    element: <SellMyApartmentBuilding />,
  },
  {
    path: '/sell-my-apartment-building/as-is-vs-remodel',
    element: <AsIsVsRemodelPage />,
  },
  {
    path: '/tips-for-selling-apartment-building',
    element: <TipsForSellingApartmentBuilding />,
  },
  {
    path: '/tips-for-selling-apartment-building/tenants-and-leases',
    element: <TenantsAndLeasesPage />,
  },
  {
    path: '/tips-for-selling-apartment-building/for-sale-by-owner',
    element: <ForSaleByOwnerPage />,
  },
  {
    path: '/apartment-building-financial-terms',
    element: <ApartmentBuildingFinancialTerms />,
  },
  {
    path: '/seller-financing-benefits',
    element: <SellerFinancingBenefits />,
  },
  {
    path: '/apartment-building-valuation',
    element: <ApartmentBuildingValuation />,
  },
  {
    path: '/privacy-and-terms',
    element: <PrivacyAndTermsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
